// extracted by mini-css-extract-plugin
export default {"projectsContainer":"article-list-component_projectsContainer__5l7Lb","carousel":"article-list-component_carousel__EOih7"};